module.exports = __webpack_public_path__ + "img/reset_scale_step_2.103ceb05.png";